import { JSX, SetStateAction, createContext, useState } from "react";

interface AccordionCollapseProps {
  expandedAccordion: string;
  setExpandedAccordion: React.Dispatch<SetStateAction<string>>;
}

export const AccordionCollapseContext = createContext<Partial<AccordionCollapseProps>>({});

export const AccordionCollapseProvider = ({ children }: { children: React.ReactNode }): JSX.Element => {
  const [expandedAccordion, setExpandedAccordion] = useState<string>();

  return (
    <AccordionCollapseContext.Provider
      value={{
        expandedAccordion,
        setExpandedAccordion,
      }}
    >
      {children}
    </AccordionCollapseContext.Provider>
  );
};
